import React from 'react';
import { JucyAuthContext, JucyAuthState } from '#/contexts/JucyAuthContext';

export const useAuth = (): JucyAuthState => React.useContext(JucyAuthContext);
